import { render, staticRenderFns } from "./igt-feature.vue?vue&type=template&id=b9bea2f4&scoped=true&"
import script from "./igt-feature.vue?vue&type=script&lang=js&"
export * from "./igt-feature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bea2f4",
  null
  
)

export default component.exports